import { safeJsonParse } from "../safeJsonParse";

const UpdateVitals = (
  event?: any,
  setVitals?: any,
  setNews?: any,
  setAlarms?: any,
  setPatientInfo?: any,
) => {
  try {
    const parsed = safeJsonParse<any>(event?.data);
    if (!parsed || !parsed.message) {
      console.warn("Skipping malformed vitals payload", event?.data);
      return {};
    }
    //console.log ("Received vitals data:", parsed);
    const data = parsed;
    if (data?.message?.alarms && setAlarms) {
      const tempAlarms = [];
      for (let i = 0; i < data.message.alarms.length; i++) {
        const alarmItem = data.message.alarms[i];
        if (alarmItem?.severity !== "Clear") {
          const alarm = {
            ...alarmItem,
            device_id: data.message.device_id,
          };
          tempAlarms.push(alarm);
        }
      }
      setAlarms(tempAlarms);
    }

    const ws_data = data?.message?.parameters;
    const news = data?.message?.["NEWS2"];
    const thresholds = data?.message?.["alarm_status"];
    const patient = data?.message?.["patient"];
    //console.log ("ws_data:", ws_data)

    if (typeof ws_data === "object" && ws_data !== null) {
      const tempIBP1 = ws_data.IBP1_Systole
        ? {
            systole: ws_data.IBP1_Systole,
            diastole: ws_data.IBP1_Diastole,
            map: ws_data.IBP1_Map,
            active_alarm: ["IBP1_Systole", "IBP1_Diastole", "IBP1_Map"].some(
              (key) =>
                ws_data?.[key]?.error_alarm_flag !== "" &&
                ws_data?.[key]?.error_alarm_flag !== "0",
            ),
          }
        : undefined;

      const tempIBP2 = ws_data.IBP2_Systole
        ? {
            systole: ws_data.IBP2_Systole,
            diastole: ws_data.IBP2_Diastole,
            map: ws_data.IBP2_Map,
            active_alarm: ["IBP2_Systole", "IBP2_Diastole", "IBP2_Map"].some(
              (key) =>
                ws_data?.[key]?.error_alarm_flag !== "" &&
                ws_data?.[key]?.error_alarm_flag !== "0",
            ),
          }
        : undefined;

      const tempNIBP = ws_data.NIBP_Systole
        ? {
            systole: ws_data.NIBP_Systole,
            diastole: ws_data.NIBP_Diastole,
            map: ws_data.NIBP_Map,
            high: thresholds?.[2]?.thresholds?.hi ?? 0,
            low: thresholds?.[2]?.thresholds?.low ?? 0,
            active_alarm: ["NIBP_Systole", "NIBP_Diastole", "NIBP_Map"].some(
              (key) =>
                ws_data?.[key]?.error_alarm_flag !== "" &&
                ws_data?.[key]?.error_alarm_flag !== "0",
            ),
          }
        : undefined;

      const tempSpo2 = ws_data.SpO2
        ? {
            sp: ws_data.SpO2,
            perf: ws_data.Perf,
            high: thresholds?.[1]?.thresholds?.hi ?? 0,
            low: thresholds?.[1]?.thresholds?.lo ?? 0,
            active_alarm: !["", "0"].includes(ws_data?.SpO2?.error_alarm_flag),
          }
        : undefined;

      const tempRR = ws_data.Resp
        ? {
            rr: ws_data.Resp,
            high: thresholds?.[0]?.thresholds?.hi ?? 0,
            low: thresholds?.[0]?.thresholds?.lo ?? 0,
            active_alarm: !["", "0"].includes(ws_data?.Resp?.error_alarm_flag),
          }
        : undefined;

      const tempEtCO2 = ws_data.EtCO2
        ? {
            co2: ws_data.EtCO2,
            high: thresholds?.[0]?.thresholds?.hi ?? 0,
            low: thresholds?.[0]?.thresholds?.lo ?? 0,
            active_alarm: !["", "0"].includes(ws_data?.EtCO2?.error_alarm_flag),
          }
        : undefined;

      const tempAct = ws_data.Act
        ? {
            act: ws_data.Act,
            high: thresholds?.[0]?.thresholds?.hi ?? 0,
            low: thresholds?.[0]?.thresholds?.lo ?? 0,
            active_alarm: !["", "0"].includes(ws_data?.Act?.error_alarm_flag),
            //active_alarm: ws_data?.Act?.error_alarm_flag !== "0"
          }
        : undefined;

      const t1_alm = ws_data?.Temp1?.error_alarm_flag
        ? !["", "0"].includes(ws_data?.Temp1?.error_alarm_flag)
        : false;
      const t2_alm = ws_data?.Temp2?.error_alarm_flag
        ? !["", "0"].includes(ws_data?.Temp2?.error_alarm_flag)
        : false;
      const tempT = ws_data.Temp1
        ? {
            t1: ws_data.Temp1,
            t2: ws_data.Temp2,
            high: thresholds?.[4]?.thresholds?.hi ?? 0,
            low: thresholds?.[4]?.thresholds?.lo ?? 0,
            active_alarm: t1_alm || t2_alm,
          }
        : undefined;

      if (ws_data.HR) {
        ws_data.HR.high = thresholds?.[3]?.hi ?? 0;
        ws_data.HR.low = thresholds?.[3]?.lo ?? 0;
        if (!ws_data?.HR?.error_alarm_flag) {
          ws_data.HR.active_alarm = false;
        } else {
          ws_data.HR.active_alarm = !["", "0"].includes(
            ws_data?.HR?.error_alarm_flag,
          );
        }
      }

      if (patient && setPatientInfo) {
        setPatientInfo(patient);
      }

      const vital_ret: any = {};

      // Only include vitals that are present in the data
      if (ws_data?.HR) vital_ret.HR = ws_data.HR;
      if (tempSpo2) vital_ret.SpO2 = tempSpo2;
      if (tempIBP1) vital_ret.IBP1 = tempIBP1;
      if (tempIBP2) vital_ret.IBP2 = tempIBP2;
      if (tempNIBP) vital_ret.NIBP = tempNIBP;
      if (tempRR) vital_ret.Resp = tempRR;
      if (tempT) vital_ret.Temp = tempT;
      if (tempEtCO2) vital_ret.EtCO2 = tempEtCO2;
      if (tempAct) vital_ret.Act = tempAct;
      if (ws_data?.ACVPU) vital_ret.ACVPU = ws_data.ACVPU;
      if (ws_data?.RespDistress) vital_ret.RespDistress = ws_data.RespDistress;
      if (ws_data?.SpO2_SPMET) vital_ret.SpO2_SPMET = ws_data.SpO2_SPMET;
      if (ws_data?.SpO2_SPCO) vital_ret.SpO2_SPCO = ws_data.SpO2_SPCO;

      // Merge with previous state instead of replacing it
      if (setVitals) setVitals((prevVitals: any) => ({ ...prevVitals, ...vital_ret }));

      if (setNews) setNews(news);

      return vital_ret;
    }
  } catch (e) {
    console.log(e);
  }
  return {
    HR: {},
    SpO2: {},
    IBP1: {},
    IBP2: {},
    Resp: {},
    Temp: {},
    ACVPU: {},
    RespDistress: {},
  };
};

export default UpdateVitals;
